import { calculateTreeCount } from '@AMIEWEB/Common/TreeView/TreeViewHelpers';
import { PlacementSearchFilterName } from '@AMIEWEB/GlobalSearch/Placement/SearchUtils';
import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';
import { getSearchLookups } from 'app/services/SharedServices/SharedServices';
import { getFilteredOptions } from '../OrderCandidateMatch/OrderCandidateMatchFilterUtils';

export const defaultFilterValues = {
  [PlacementSearchFilterName.archiveStatus]: { id: 0, labelPrefix: 'Archive', name: 'No', value: 'N' },
  [PlacementSearchFilterName.status]: [
    {
      name: 'Submission',
      value: '1',
      children: [
        {
          name: 'Waiting for Clearance',
          value: '1',
        },
        {
          name: 'Request File Out',
          value: '2',
        },
        {
          name: 'Sent',
          value: '3',
        },
        {
          name: 'Interview Scheduled',
          value: '16',
        },
        {
          name: 'Interviewed',
          value: '6',
        },
        {
          name: 'OK to Send',
          value: '8',
        },
        {
          name: 'Declined by Traveler',
          value: '4',
        },
        {
          name: 'Declined by Facility',
          value: '5',
        },
        {
          name: 'Request Cancelled',
          value: '7',
        },
      ],
    },
    {
      name: 'Offer',
      value: '3',
      children: [
        {
          name: 'Declined by Traveler',
          value: '4',
        },
        {
          name: 'Declined by Facility',
          value: '5',
        },
        {
          name: 'Offer by Facility',
          value: '9',
        },
        {
          name: 'Offer Booked by Traveler',
          value: '10',
        },
        {
          name: 'Traveler Accepts',
          value: '11',
        },
        {
          name: 'Facility Confirms',
          value: '12',
        },
      ],
    },
    {
      name: 'Booking',
      value: '4',
      children: [
        {
          name: 'Booked',
          value: '13',
        },
        {
          name: 'Booking Approved',
          value: '14',
        },
        {
          name: 'Waiting Good To Go',
          value: '15',
        },
        {
          name: 'Postponement Warning',
          value: '17',
        },
        {
          name: 'Good To Go',
          value: '18',
        },
      ],
    },
    {
      name: 'Assignment',
      value: '5',
      children: [
        {
          name: 'On Assignment',
          value: '23',
        },
        {
          name: 'Assignment Complete',
          value: '24',
        },
      ],
    },
  ],
  [PlacementSearchFilterName.region]: null,
};
export const archiveOpts = [
  { id: 0, labelPrefix: 'Archive', name: 'No', value: 'N' },
  { id: 1, labelPrefix: 'Archive', name: 'Yes', value: 'Y' },
];

export class CandidatePlacementsFilter {
  constructor(public filterSpecs: any, public t: any, public regionFlag?: boolean) {}

  getOrderPlacementSearchFilterSpecs = () => {
    const filters = [
      {
        filterName: this.t('search.globalSearch.placement.filterNames.pid'),
        name: PlacementSearchFilterName.pid,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        fetchOptions: async key => await getSearchLookups('PID', key),
        isMultiSelect: true,
        searchOnCharacterCount: 1,
        applyOnClickAway: true,
        applyOnEnter: true,
        isSelectAll: true,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.candidate'),
        name: PlacementSearchFilterName.candidate,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        fetchOptions: async key => await getSearchLookups('candidates', key),
        isMultiSelect: true,
        searchOnCharacterCount: 1,
        applyOnClickAway: true,
        applyOnEnter: true,
        isSelectAll: true,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.archive'),
        name: PlacementSearchFilterName.archiveStatus,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        options: archiveOpts,
        hideClearAll: true,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.placementStatus'),
        name: PlacementSearchFilterName.status,
        type: FilterCompTypes.TREE,
        isMultiSelect: true,
        options: this.filterSpecs.statusOpts,
        placeholder: 'Select',
        version2: true,
        returnsObjectAsValue: true,
        size: 'large',
        customSelectedCount: value => calculateTreeCount(value),
        applyOnClickAway: true,
        applyOnEnter: true,
        isSelectAll: true,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.extensionStatus'),
        name: PlacementSearchFilterName.extensionStatus,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        searchOnCharacterCount: 1,
        fetchOptions: async key => await getFilteredOptions(this.filterSpecs.extensionOpts, key),
        isMultiSelect: true,
        isSelectAll: true,
        applyOnClickAway: true,
        applyOnEnter: true,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.startDate'),
        name: PlacementSearchFilterName.startDate,
        type: FilterCompTypes.DATERANGEV2,
        variant: 'outlined',
        secondaryLabel: this.t('search.globalSearch.placement.filterNames.startDate'),
        useMaxWidth: true,
        maxWidth: 210,
        clickAway: true,
        disablePortal: true,
        quickSelect: false,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.endDate'),
        name: PlacementSearchFilterName.endDate,
        type: FilterCompTypes.DATERANGEV2,
        variant: 'outlined',
        secondaryLabel: this.t('search.globalSearch.placement.filterNames.endDate'),
        useMaxWidth: true,
        maxWidth: 210,
        clickAway: true,
        disablePortal: true,
        quickSelect: false,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.recruiter'),
        name: PlacementSearchFilterName.recruiter,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        fetchOptions: async key => await getSearchLookups('recruiters', key),
        isMultiSelect: true,
        searchOnCharacterCount: 1,
        applyOnClickAway: true,
        applyOnEnter: true,
        isSelectAll: true,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.acctManager'),
        name: PlacementSearchFilterName.accountManager,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        fetchOptions: async key => await getSearchLookups('accountmanagers', key),
        isMultiSelect: true,
        searchOnCharacterCount: 1,
        applyOnClickAway: true,
        applyOnEnter: true,
        isSelectAll: true,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.credAnalyst'),
        name: PlacementSearchFilterName.credentialingAnalyst,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        fetchOptions: async key => await getSearchLookups('credentialinganalysts', key),
        isMultiSelect: true,
        searchOnCharacterCount: 1,
        applyOnClickAway: true,
        applyOnEnter: true,
        isSelectAll: true,
      },
      {
        filterName: this.t('search.globalSearch.placement.filterNames.cuedTo'),
        name: PlacementSearchFilterName.placementCuedTo,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        fetchOptions: async key => await getSearchLookups('cuedto', key),
        isMultiSelect: true,
        searchOnCharacterCount: 1,
        applyOnClickAway: true,
        applyOnEnter: true,
        isSelectAll: true,
      },
    ];
    const regionFilter = [
      {
        filterName: this.t('search.globalSearch.placement.filterNames.region'),
        name: PlacementSearchFilterName.region,
        type: FilterCompTypes.TYPEAHEADDROPDOWN,
        isMultiSelect: true,
        fetchOptions: async key => await getFilteredOptions(this.filterSpecs.regionOpts, key),
        isSelectAll: true,
        applyOnClickAway: true,
        applyOnEnter: true,
        searchOnCharacterCount: 1,
      },
    ];
    const filterList = this.regionFlag ? [...filters, ...regionFilter] : filters;
    return filterList;
  };
}

export const fetchDefaultStates = (states, licenses) => {
  const resultMap = {};
  licenses.forEach(item => {
    if (!resultMap[item.requirementTypeId]) {
      if (item.state) {
        resultMap[item.requirementTypeId] = [];
      }
    }
    if (item.state) {
      resultMap[item.requirementTypeId].push(
        states?.find(state => {
          if (state?.name === item.state) return state;
        }),
      );
    }
  });

  // Convert the resultMap to an array of objects
  const resultArray = Object.entries(resultMap).map(([requirementTypeId, states]) => ({
    requirementTypeId: parseInt(requirementTypeId),
    states,
  }));

  return resultArray;
};
